import { CSS_COLORS } from "../../../styles/styles-css-variables";
import styled from "@emotion/styled";
import { FONTS } from "../../../styles/fonts";

export const PremiumBadge = styled.span`
  text-transform: uppercase;

  border: 1px solid ${CSS_COLORS.Green};
  border-radius: 8px;
  ${FONTS.SwarovskiFutura300};

  font-size: 16px;
  color: ${CSS_COLORS.Green};
  letter-spacing: 1px;
  text-align: center;

  padding: 12px 20px 8px;

  display: inline-block;
`;
